var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full mx-auto border border-gray-600 bg-no-repeat bg-center bg-cover",style:(("background-image: url('" + _vm.avatarURL + "')"))})}
var staticRenderFns = []

export { render, staticRenderFns }